const myInterval = setInterval(myTimer, 2000);

function myTimer() {
  if(!document.querySelector('fw-embed-feed')) return;
  let showdowRootGrid = document.querySelector('fw-embed-feed').shadowRoot.querySelector('.fwn-grid'),
    thumbnailCaption = showdowRootGrid.querySelectorAll('.fw-thumbnail-caption');
    if(showdowRootGrid){
    clearInterval(myInterval);
     thumbnailCaption.forEach(function(ele){
        ele.style.fontWeight = '400';
     });
  } 
  
  let showdowRoot = document.querySelector('fw-storyblock').shadowRoot.querySelectorAll('[data-testid="storyblock"]');
  if(showdowRoot){
  clearInterval(myInterval);
   showdowRoot.forEach(function(ele) {
     ele.style.height = "100vh";
   });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const storyblockItem = document.querySelector('fw-storyblock');
  if (storyblockItem) {
    var storyblocks = storyblockItem.shadowRoot.querySelectorAll('[data-testid="storyblock"] video');
    if (storyblocks) {
      storyblocks.forEach(function(storyblock) {
        storyblock.style.objectFit = "unset";
      });
    }
  }
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

var giftNote = class extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.note-button');
    this.textarea = this.querySelector('textarea');
    this.form = this.querySelector('.note-form');


    this.setListeners();
  }

  setListeners() {
    // On button click
    this.button.addEventListener('click', this.onButtonClick.bind(this));
    
    // Update note in the cart
    this.textarea.addEventListener(
      'change',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300)
    );
  }

  onButtonClick(event) {
    console.log(this.button.classList.contains('active'))
    if (this.button.classList.contains('active')) {
      this.button.classList.remove('active');
      slideUp(this.form, 300);
      
      this.clearNote();
    } else {
      this.button.classList.add('active');
      slideDown(this.form, 300);
    }
  }

  clearNote() {
    this.textarea.value = '';
    this.textarea.dispatchEvent(new Event('change'));
  }
}

customElements.define('cart-note', giftNote);

window.refreshCartDrawerFromPage = async function () {
  try {
    const currentUrl = window.location.href;

    const res = await fetch(currentUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newCartDrawer = doc.querySelector('cart-drawer');
    const oldCartDrawer = document.querySelector('cart-drawer');

    if (!newCartDrawer || !oldCartDrawer) {
      console.warn("Cart drawer element missing. Cannot refresh.");
      return;
    }

    oldCartDrawer.outerHTML = newCartDrawer.outerHTML;

    if (document.querySelector("cart-drawer #cart-drawer").getAttribute("aria-hidden") == "true") {
      document.querySelector('cart-drawer').open();
    }

  } catch (error) {
    console.error("Cart drawer refresh failed:", error);
  }
};

(function() {
  // Store original fetch and XMLHttpRequest
  const origFetch = window.fetch;
  const origXHROpen = XMLHttpRequest.prototype.open;

  // Utility to check URL patterns
  function matchesCartBot(url) {
    const patterns = [
      '/change.js',
      '/update.js',
      '/add.js',
      '/change',
      '/update',
      '/add'
    ];
    return patterns.some(p => url.includes(p) && url.includes('cartbot-cart-call'));
  }

  // Wrap fetch
  window.fetch = async function(...args) {
    const response = await origFetch.apply(this, args);
    const url = args[0];
    if (matchesCartBot(url)) {
      console.log('Cart update detected via fetch:', url);
      if (typeof window.refreshCartDrawerFromPage === 'function') {
        window.refreshCartDrawerFromPage();
      }
    }
    return response;
  };

  // Wrap XMLHttpRequest
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.addEventListener('load', function() {
      if (matchesCartBot(url)) {
        console.log('Cart update detected via XHR:', url);
        if (typeof window.refreshCartDrawerFromPage === 'function') {
          window.refreshCartDrawerFromPage();
        }
      }
    });
    return origXHROpen.call(this, method, url, ...rest);
  };

  // console.info('CartBot network watcher initialized.');
})();
